import { axios } from '@Root/API'

export const getOrganisations = params => {
	return axios.get('organisations', {
		params,
	})
}
